module.exports = __webpack_public_path__ + "img/react.37fe8322.jpg";